var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 53,
    viewBox: "0 0 90 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.a{stroke:#dadada;stroke-miterlimit:10;}.b{fill:#c4c4c4;}.b,.d{stroke:#c4c4c4;}.b,.c{stroke-width:2px;}.c{fill:#0072c6;stroke:#0072c6;}.d{stroke-width:0.5px;}.e{stroke:none;}.f{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16246 24425)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-16246 -24425)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 90,
    height: 53,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 52,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-16238 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.008,
    cy: 3.008,
    r: 3.008
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.008,
    cy: 3.008,
    r: 2.008
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-16206.207 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-16223.75 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-16188.293 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-16171.293 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-16239 -24408)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 75,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.25,
    y: 0.25,
    width: 74.5,
    height: 30.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle3);
export default __webpack_public_path__ + "static/media/style3.799278ff5075b5cfe9b6b81e9781ef37.svg";
export { ForwardRef as ReactComponent };